import { render, staticRenderFns } from "./StyleForm.vue?vue&type=template&id=7b872d18"
import script from "./StyleForm.vue?vue&type=script&lang=ts"
export * from "./StyleForm.vue?vue&type=script&lang=ts"
import style0 from "./StyleForm.vue?vue&type=style&index=0&id=7b872d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports